<template>
  <div
    class="group relative flex flex-row items-center gap-4 overflow-hidden p-4"
    :class="[!disabled && 'cursor-pointer']"
  >
    <BaseIcon v-if="icon" size="24" class="text-on-surface-variant">{{ icon }}</BaseIcon>
    <div class="flex shrink grow flex-col select-none">
      <span class="text-title-medium">{{ title }}</span>
      <span v-if="description" class="text-body-medium text-on-surface-variant">{{
        description
      }}</span>
    </div>
    <BaseStateLayer v-if="!disabled" />
  </div>
</template>

<script setup lang="ts">
  import BaseIcon from '../icon/BaseIcon.vue'
  import BaseStateLayer from '../state-layer/BaseStateLayer.vue'

  interface Props {
    title: string
    description?: string
    icon?: string
    disabled?: boolean
  }

  defineProps<Props>()
</script>
